import { render, staticRenderFns } from "./DelayedActionButton.vue?vue&type=template&id=247897ca&"
import script from "./DelayedActionButton.vue?vue&type=script&lang=js&"
export * from "./DelayedActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports